import User from "./items/User";
import {Config} from "./Config";
export default class Lines extends Config{
	constructor(default_url:string, url:string) {
		super(default_url, url);
	}

	protected addLineIfHasFatherOrMother(user:User):void{
		var color:string = '#d19c69';
		// add up lines
		var upToLineName:string = user.id_key + '_is_to_up';
		this.ground.removeByName(upToLineName);
		var x:number = user.x + user.width/2;
		this.addLine(
			upToLineName,
			x,
			user.y,
			x,
			user.y - this.upLineHeight,
			color
		);
	}

	protected addBrotherLine(from:User, to:User){
		var color:string = '#d19c69';
		var name      :string = 'brotherLine_' + from.id_key + '_' + to.id_key;
		var nameInvers:string = 'brotherLine_' + to.id_key + '_' + from.id_key;
		this.ground.removeByName(name);
		this.ground.removeByName(nameInvers);
		var boxHalfHeight:number = from.height/2;
		var fromX        :number = from.x;
		var toX          :number = to.x;
		if ( fromX < toX) {
			// console.log('right to left', name);
			fromX += from.width/2;
			toX += from.width/2;
			// color = '#22dd22';
		}else{
			fromX += from.width/2;
			toX += from.width/2;
		}
		var fromY:number = from.y - this.upLineHeight;
		var toY  :number = to.y - this.upLineHeight;
		this.addLine(name, fromX, fromY, toX, toY, color);
	}

	protected addParentLine(from:any, to:any){
		var name      :string = 'partnerLine_' + from.id_key+'To'+to.id_key;
		var nameInvers:string = 'partnerLine_' + to.id_key+'To'+from.id_key;
		this.ground.removeByName(name);
		this.ground.removeByName(nameInvers);
		var boxHalfHeight:number = from.height/2;
		var fromX        :number = from.x;
		var toX          :number = to.x;
		if ( fromX < toX) {
			// to right
			fromX += from.width;
		}else{
			// to left
			toX += to.width;
		}
		var fromY:number = from.y + boxHalfHeight;
		var toY  :number = to.y + boxHalfHeight;
		var distanceX:number = from.x - to.x;
		var alpha = 1;
		if ( distanceX < 0 ) {
			distanceX *= -1;
		}
		if ( distanceX < 60 ) {
			alpha = 0;
			fromY += from.height/2;
		}
		this.addLine(name, fromX, fromY, toX, toY, '#d19c69', alpha);

		var lineX = 0;
        var bottomLineY:number = 0;
		// if ( fromX < toX ) {
		if ( from.x < to.x ) {
            if ( from.levelIndex < 0 ) {
                lineX = fromX + ( toX - fromX ) / 2;
            }else{
                lineX = from.x + from.width/2;
            }
            bottomLineY =  from.y;
		}else{
            if ( to.levelIndex < 0 ) {
                lineX = toX + ( fromX - toX ) / 2;
            }else{
                lineX = to.x + to.width/2;
            }
            bottomLineY = to.y;
		}
		// remove old half bottom rows
		var heightMod:number = 0;
		if ( distanceX < 60 ) {
			// fromY += 20;
            if ( to.levelIndex < 0 ) {
                heightMod = -65;
            }else{
                if ( from.itemNumber === 2 ) {
                    heightMod = -65;
                }else{
                    heightMod = -85;

                }
            }
		}
		this.addParentLineBottom('partnerLine_' + from.id_key, 'partnerLine_' + to.id_key, lineX, fromY, from, heightMod);
	}

	protected addSingleParentLine(from:any){
		var name      :string = 'partneSinglerLine_' + from.id_key;
		var fromY:number         = from.y + from.height;
		var lineX = from.x + ( from.width ) / 2;
		var heightMod:number = -65;
		this.addParentLineBottom(name, name, lineX, fromY, from, heightMod);
	}

	protected removParentLienBottom(name:string, nameInvers:string):string{
		var downLineName       :string = name +'_down';
		var downInverseLineName:string = nameInvers +'_down';
		this.ground.removeByName(downLineName);
		this.ground.removeByName(downInverseLineName);
		return downLineName;
	}

	protected addParentLineBottom(name:string, nameInvers:string, lineX:number, fromY:number, item:User, heightMod?:number, color:string='#d19c69'):void{
		var downLineName:string = this.removParentLienBottom(name, nameInvers);
		var lineEnd:number = fromY + this.boxvVerticalDistance - ( item.height/2 + this.upLineHeight ) ;
		if ( heightMod !== undefined ) {
			lineEnd += heightMod;
		}
		this.addLine(
			downLineName,
			lineX,
			fromY,
			lineX,
			lineEnd,
			color
		);
	}

	protected addLine(name:string, fromX:number, fromY:number, toX:number, toY:number, color?: string, alpha?:number):void{
		if ( color === undefined ) {
			var color:string = '#000000';
		}
		var line = new createjs.Shape();
		line.name = name;
		line.graphics.setStrokeStyle(3);
		line.graphics.beginStroke(color);
		line.graphics.moveTo(fromX, fromY);
		line.graphics.lineTo(toX, toY);
		line.graphics.endStroke();
		line.on("mousedown", (evt) => {
			console.log(line.name, fromX, fromY);
		});
		if ( alpha !== undefined ) {
			line.alpha = alpha;
		}
		this.ground.addChild(line);
	}
}



// WEBPACK FOOTER //
// ./components/family_tree/Lines.ts